/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { Text } from 'hocs/localization'
import { getFormattedTextOrDefault } from 'utils/printedData'
import Table from 'apps/Table'
import { toCurrency } from 'utils/price'
import { COLUMN_KEYS } from './constants'
import * as styles from './PaymentHistory.scss'
import { getPrintedDateLocal } from 'shared/utils/date'

const cx = classNames.bind(styles)

interface IProps {
  t: Text
  items: [],
  downloadReceipt: (id) => Promise<{}>,
}

class PaymentHistory extends React.Component<IProps> {

  private onRequestReceipt = (invoiceId) => {
    this.props.downloadReceipt(invoiceId);
  }

  public render () {

    const {
      t,
      items,
    } = this.props

    const noValue = () => <div className={styles.noData}>-</div>

    const createColumnsConfig = (t) => {
      return [
        {
          title: t('type'),
          dataKey: COLUMN_KEYS.type,
          width: '25%',
        },
        {
          title: t('status'),
          dataKey: COLUMN_KEYS.status,
          cellContentRender: status => t(`paymentStatuses.${status}`),
          width: '20%',
        },
        {
          title: t('date'),
          dataKey: COLUMN_KEYS.date,
          cellContentRender: getFormattedTextOrDefault(getPrintedDateLocal, noValue),
          width: '20%',
        },
        {
          title: t('price'),
          dataKey: COLUMN_KEYS.price,
          cellContentRender: price => {
            return t('priceValue', { amount: toCurrency(price) })
          },
          width: '20%',
        },
        {
          title: t('receipt'),
          dataKey: COLUMN_KEYS.id,
          width: '15%',
          cellContentRender: id => {
            return (
              <div className={styles.link} onClick={() => this.onRequestReceipt(id)}>
                {t('receiptLink')}
              </div>
            )
          },
        },
      ]
    }

    return(
      <div className={cx(styles.tableWrap, 'table-responsive')}>
        <Table columns={createColumnsConfig(t)} data={items} />
      </div>
    )
  }
}

export default PaymentHistory
